import { qsa } from '@fluorescent/dom';

import { section } from '@/neon';
import autoPlay from '@/lib/auto-play';

section('collage', {
  onLoad() {
    autoPlay(qsa('.collage__block-video', this.container));
  },
  onUnload() {},
});
